import {
    SUBMIT_FINAL,
    SUBMIT_BUTTON_UPDATE
  } from '../config/constants';
  
  export const submitFinal = (bool) => ({
    type: SUBMIT_FINAL,
    payload: bool
  });
  
  export const submitButtonUpdate = (bool) => ({
    type: SUBMIT_BUTTON_UPDATE,
    payload: bool
  });
